import classNames from "classnames";

import { Button } from "studio-design-system";

import { StudioUser } from "~/api/userApi";
import { EmptyIcon } from "~/components/BTSInProductVideoPage/Review/Modals/RateModal/icons/EmptyIcon";
import { FilledIcon } from "~/components/BTSInProductVideoPage/Review/Modals/RateModal/icons/FilledIcon";
import { ProfilePic } from "~/components/common/ProfilePic";

import * as styles from "../Modals.css";

export const SuccessModal = ({
  user,
  isLoading,
  productReviewScore,
  productReviewText,
  handleContinue,
}: {
  user: StudioUser | null;
  isLoading: boolean;
  productReviewScore: number;
  productReviewText: string;
  handleContinue: () => void;
}) => {
  return (
    <div className={styles.container}>
      <h3 className={styles.modalTitle}>Thanks for helping our community!</h3>
      <div className={styles.successReview}>
        <div className={styles.userNameContainer}>
          <ProfilePic imageUrl={user?.profilePhoto} firstName={user?.firstName} size={32} />
          <p>
            {user?.firstName} {user?.lastName}
          </p>
        </div>
        <div className={styles.reviewContainer}>
          <div className={classNames(styles.smallGap, styles.ratingContainer)}>
            {[...new Array(5)].map((_, index) => {
              const showEmptyIcon = productReviewScore === -1 || productReviewScore < index + 1;
              const isRatingWithPrecision = productReviewScore % 1 !== 0;
              const isRatingEqualToIndex = Math.ceil(productReviewScore) === index + 1;
              const showRatingWithPrecision = isRatingWithPrecision && isRatingEqualToIndex;
              return (
                <div
                  key={index}
                  className={classNames(styles.successRating, styles.ratingSelector)}
                >
                  <div
                    style={{
                      width: showRatingWithPrecision ? `${(productReviewScore % 1) * 100}%` : "0%",
                      overflow: "hidden",
                      position: "absolute",
                    }}
                  >
                    <FilledIcon width={18} height={18} />
                  </div>
                  <div>
                    {showEmptyIcon ? (
                      <EmptyIcon width={18} height={18} />
                    ) : (
                      <FilledIcon width={18} height={18} />
                    )}
                  </div>
                </div>
              );
            })}
          </div>
          <p>{productReviewText || "There are no written comments for your review."}</p>
        </div>
      </div>
      <Button className={styles.ctaButton} onClick={handleContinue} isLoading={isLoading}>
        Save and Exit
      </Button>
    </div>
  );
};
